import { Link } from '@tanstack/react-router'
import type { InferResponseType } from 'hono/client'
import {
  Download,
  MoreVertical,
  PencilIcon,
  ReplaceIcon,
  TrashIcon,
  ViewIcon,
} from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { apiClient } from '@/apiClient'

// Type for the single document response from the API
type DocumentWithDetails = InferResponseType<
  (typeof apiClient.documents)[':documentId']['$get']
>['data']

interface DocumentViewSearch {
  mode?: 'view' | 'modify'
  pageNum?: number
  previewMode?: 'image' | 'markdown'
  tab?: 'details' | 'preview' | 'attachments' | 'logs'
}

interface DocumentActionsMenuProps {
  documentId: string
  search: DocumentViewSearch
  mode: 'view' | 'modify'
  document: DocumentWithDetails | undefined
  onChangeStatus: () => void
  onDownload: () => void
  onDelete: () => void
}

export function DocumentActionsMenu({
  documentId,
  search,
  mode,
  document,
  onChangeStatus,
  onDownload,
  onDelete,
}: DocumentActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="bg-background hover:bg-accent size-8 p-0"
        >
          <MoreVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <Link
            to="/documents/$documentId"
            params={{ documentId }}
            search={{
              ...search,
              mode: mode === 'view' ? 'modify' : 'view',
            }}
            replace
            className="flex gap-2"
          >
            {mode === 'view' ? (
              <PencilIcon className="size-4" />
            ) : (
              <ViewIcon className="size-4" />
            )}
            {mode === 'view' ? 'Modifica' : 'Visualizza'}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onChangeStatus} className="gap-2">
          <ReplaceIcon className="size-4" />
          Cambia stato
        </DropdownMenuItem>
        {document?.file_id && (
          <DropdownMenuItem onClick={onDownload} className="gap-2">
            <Download className="size-4" />
            Scarica
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onDelete} className="gap-2">
          <TrashIcon className="size-4" />
          Elimina
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
